import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const addParam = (params, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    params.append(key, value);
  }
};

const vendorStorefrontController = {
  getSettings: ({ Authorization, companyId, companyID, jwt } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/storefront/v1/settings",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  pauseNewOrders: ({
    Authorization,
    companyId,
    companyID,
    jwt,
    paused,
    pauseOrders,
    request,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "paused", paused);
    addParam(params, "pauseOrders", pauseOrders);

    return Utils.controller(
      "api/vendor/storefront/v1/pause-orders",
      request || "",
      "PATCH",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  saveSettings: ({
    Authorization,
    companyId,
    companyID,
    jwt,
    request,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/storefront/v1/settings",
      request,
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },

  setStoreOnline: ({
    Authorization,
    companyId,
    companyID,
    isOnline,
    jwt,
    online,
    reason,
    request,
    storeOnline,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);
    addParam(params, "reason", reason);
    addParam(params, "storeOnline", storeOnline ?? online ?? isOnline);

    return Utils.controller(
      "api/vendor/storefront/v1/online",
      request || "",
      "PATCH",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "",
    );
  },

  updateHours: ({
    Authorization,
    companyId,
    companyID,
    jwt,
    hours,
    request,
  } = {}) => {
    const params = new URLSearchParams();

    addParam(params, "companyId", companyId || companyID);

    return Utils.controller(
      "api/vendor/storefront/v1/hours",
      request || { hours },
      "PUT",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
      "*/*",
    );
  },
};

export default vendorStorefrontController;
